/**
 * browser-voices.js — /voice-gender «Голоса ИИ · в браузере»: the person's recording in a
 * catalogue voice, converted ON THE DEVICE by window.VoiceConvert (per-voice RVC v2 + our
 * RMVPE pitch). No upload, no tokens: the tool's daily cap is the only limit, billed on a
 * delivered file like «Ваш голос» (__toolLimit 'voice-gender', the same unit).
 *
 * The blade owns the source (one rail for every lane — #8437: a lane that did not own its
 * input converted our example five times) and hands this lane a narrow API:
 *   VGBrowserVoices.init({
 *     t, ae, $, clips,                     dictionary, telemetry, getElementById, VGClips
 *     voices, tags, name(v),               catalogue with packs (BrowserVoices), tag words
 *     verdict({max, min}),                 the shared source verdict {state, text, why, mix}
 *     trimmed(),                           the selection as an AudioBuffer
 *     encode(buffer, fmt) → {blob, ext},   the page's own WAV/MP3 writers
 *     act(kind),                           'record' | 'trim' | 'dsp' — the rail does it
 *     analysis(),                          redraw the pitch instrument (target moved)
 *     maxSec, minSec
 *   }) → { sync, open, reset }
 *
 * Order of what the person still has to do, as on the paid lane: source → voice → device.
 */
(function () {
'use strict';

function init(api) {
    var t = api.t, ae = api.ae, $ = api.$;
    var sec = $('vgNvSec');
    if (!sec || !window.VoiceConvert || !window.VGVoiceCards) return null;
    var voices = api.voices || [], picked = null, busy = false, sup = null, ctrl = null;
    var result = null;              // { buffer: AudioBuffer, voice, semitones, provider }
    var opened = false;

    var box = $('vgNvVoices'), filterBar = $('vgNvFilter');
    window.VGVoiceCards.render(box, voices, {
        t: t, tags: api.tags, clips: api.clips, clipPrefix: 'nv:', name: api.name,
        onPreview: function (v) { ae('nv_voice_preview', { v: v.id }); },
        onPick: function (v) { picked = v; flt.apply(); sync(); if (api.analysis) api.analysis(); ae('nv_voice_pick', { v: v.id }); }
    });
    $('vgNvSemi').addEventListener('change', function () { if (api.analysis) api.analysis(); ae('nv_semi', { v: this.value }); });

    // Where this lane takes a measured voice, for the page's pitch instrument: the picked
    // voice and «Авто» (the server lane's rule, VcShared.autoSemitones) or the chosen shift.
    window.__vgNvTargetHz = function (measured) {
        if (!picked || !(measured >= 50 && measured <= 500) || !window.VcShared) return 0;
        var v = $('vgNvSemi').value;
        var semi = v === 'auto' ? window.VcShared.autoSemitones(measured, picked.f0) : (+v || 0);
        return measured * Math.pow(2, semi / 12);
    };
    var flt = window.VGVoiceCards.filter(filterBar, box, voices, { t: t,
        onChange: function (f) { ae('nv_voice_filter', { f: f }); },
        onLang: function (l) { ae('nv_voice_lang', { l: l }); } });

    function fmtDur(s) { s = Math.max(0, Math.round(s)); var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; }
    function setStatus(msg, cancellable) {
        $('vgNvStatus').hidden = !msg; $('vgNvStatusText').textContent = msg || '';
        $('vgNvCancel').hidden = !cancellable;
    }

    // ── what this device will do: decided before a byte moves ──────────────────────────
    function deviceLine() {
        var el = $('vgNvDevice');
        if (!sup) { el.hidden = true; return; }
        if (!sup.ok) { el.hidden = false; el.textContent = t('nv_dev_no'); return; }
        var aff = window.__deviceCap && window.__deviceCap.modelAffordable
            ? window.__deviceCap.modelAffordable({ mb: 215, url: document.querySelector('meta[name="vc-cv-url"]').content }) : { ok: true, cached: null };
        var parts = [];
        parts.push(sup.providers[0] === 'webgpu' ? t('nv_dev_gpu') : t('nv_dev_cpu'));
        if (aff.cached !== true) parts.push(aff.minutes ? t('nv_dev_download_min').replace(':min', aff.minutes) : t('nv_dev_download'));
        el.hidden = false; el.textContent = parts.join(' · ');
    }
    function etaLine(dur) {
        var el = $('vgNvEta');
        var est = window.VoiceConvert.estimateWorkS(dur, true);
        // before the engine has timed this device: conversion + pitch per second of audio,
        // e2e stand 18.10 on a laptop — WebGPU ≈0.25 s/s, one CPU thread 5.7 s/s (52 s for 9.1 s)
        if (est == null && sup && sup.ok) est = dur * (sup.providers[0] === 'webgpu' ? 0.25 : 5.7);
        el.textContent = est != null && dur > 0 ? t('nv_eta').replace(':time', fmtDur(Math.max(1, est))) : '';
    }

    function blocker() {
        var src = api.verdict({ max: api.maxSec, min: api.minSec });
        if (src.why) return { why: src.why, src: src };
        if (!picked) return { why: 'voice', src: src };
        if (sup && !sup.ok) return { why: 'device', src: src };
        return { why: null, src: src };
    }
    var WHY = { none: 'ai_why_none', demo: 'ai_why_demo', wait: 'ai_why_wait', silent: 'ai_why_silent',
                long: 'nv_why_long', short: 'ai_why_short', voice: 'ai_why_voice', device: 'nv_dev_no' };
    var ACT = { none: 'record', demo: 'record', silent: 'record', short: 'record', long: 'trim', device: 'dsp' };
    var ACT_LABEL = { record: 'ai_act_record', trim: 'ai_act_trim', dsp: 'nv_act_dsp' };

    function sync() {
        var b = blocker(), src = b.src;
        $('vgNvSrc').setAttribute('data-state', src.state);
        $('vgNvSrcV').textContent = src.text;
        $('vgNvWarn').hidden = !src.mix;
        $('vgNvRun').setAttribute('aria-disabled', (busy || b.why) ? 'true' : 'false');
        var why = $('vgNvWhy'), act = $('vgNvWhyAct');
        if (b.why && !busy) {
            $('vgNvWhyText').textContent = t(WHY[b.why]).replace(':max', Math.round(api.maxSec / 60)).replace(':min', api.minSec);
            var ak = ACT[b.why];
            act.hidden = !ak;
            if (ak) { act.setAttribute('data-act', ak); act.textContent = t(ACT_LABEL[ak]); }
            why.hidden = false;
        } else why.hidden = true;
        var buf = src.state === 'ok' ? api.trimmed() : null;
        etaLine(buf ? buf.duration : 0);
        deviceLine();
    }

    function open() {
        if (!opened) {
            opened = true;
            ae('nv_open', { voices: voices.length });
            window.VoiceConvert.support({ allowWasm: true }).then(function (s) {
                sup = s;
                ae('nv_support', { ok: s.ok ? 1 : 0, ep: s.ok ? s.providers[0] : null, reason: s.reason || s.gpuReason || null });
                sync();
            });
        }
        sync();
    }

    function nudge(el) {
        if (!el) return;
        try { el.scrollIntoView({ block: 'nearest' }); } catch (e) {}
        el.classList.remove('vg-nudge'); void el.offsetWidth; el.classList.add('vg-nudge');
        setTimeout(function () { el.classList.remove('vg-nudge'); }, 1500);
    }
    $('vgNvWhyAct').addEventListener('click', function () {
        var k = this.getAttribute('data-act');
        ae('nv_why_act', { act: k });
        api.act(k);
    });

    function phaseText(p, phase) {
        var pct = Math.round(p * 100) + ' %';
        if (phase === 'model' || phase === 'compile') return t('nv_st_model') + ' ' + pct;
        if (phase === 'voice') return t('nv_st_voice') + ' ' + pct;
        if (phase === 'pitch') return t('nv_st_pitch');
        return t('nv_st_convert') + ' ' + pct;
    }

    $('vgNvRun').addEventListener('click', function () {
        var b = blocker();
        if (busy) return;
        if (b.why) {
            ae('nv_blocked_click', { why: b.why });
            if (b.why === 'voice') return nudge(box);
            if (b.why === 'wait' || b.why === 'long') return nudge($('vgNvSrc'));
            return nudge($('vgNvWhy'));
        }
        var buf = api.trimmed();
        if (!buf) return;
        busy = true; ctrl = new AbortController();
        $('vgNvResult').hidden = true; result = null;
        var started = Date.now(), voice = picked, semi = $('vgNvSemi').value;
        setStatus(t('nv_st_model'), true); sync();
        ae('nv_run', { v: voice.id, sec: Math.round(buf.duration), semi: semi });
        window.VoiceConvert.convert(buf, {
            slug: 'voice-gender', signal: ctrl.signal, allowWasm: true,
            voice: { id: voice.id, url: voice.pack, fallbackUrl: voice.pack_fallback },
            semitones: semi === 'auto' ? 'auto' : +semi, targetF0: voice.f0,
            onProgress: function (p, phase) { setStatus(phaseText(p, phase), true); }
        }).then(function (r) {
            busy = false; setStatus('');
            var ab = new AudioBuffer({ length: r.audio.length, numberOfChannels: 1, sampleRate: r.sr });
            ab.copyToChannel(r.audio, 0);
            result = { buffer: ab, voice: voice, semitones: r.semitones, provider: r.provider };
            // the conversion is synthetic speech in another voice: the AI mark is owed (ai-output.php)
            if (window.__aiOutput) window.__aiOutput.used();
            var wav = api.encode(ab, 'wav');
            Promise.resolve(wav).then(function (w) {
                if (window.__skipBlobAutoTrack) window.__skipBlobAutoTrack(w.blob);   // a preview is not a delivery
                $('vgNvAudio').src = URL.createObjectURL(w.blob);
            });
            $('vgNvResultMeta').textContent = api.name(voice) + (r.semitones ? ' · ' + t('nv_shift').replace(':n', (r.semitones > 0 ? '+' : '') + r.semitones) : '');
            $('vgNvResult').hidden = false;
            sync();
            ae('nv_done', { v: voice.id, ms: Date.now() - started, work_ms: r.ms, f0_ms: r.f0Ms, ep: r.provider, semi: r.semitones, sec: Math.round(buf.duration) });
            if (window.__aeToolComplete) try { window.__aeToolComplete({ lane: 'browser' }); } catch (e) {}
        }, function (e) {
            busy = false; setStatus('');
            var aborted = window.__isUserCancel ? window.__isUserCancel(e, ctrl.signal) : (e && e.name === 'AbortError');
            sync();
            if (aborted) { ae('nv_cancel'); return; }
            var code = (e && e.code) || '';
            var say = /unsupported|low_memory|device/.test(code) ? t('nv_dev_no')
                    : /fetch|network|download|pack_/.test(code + ' ' + (e && e.message)) ? t('nv_err_download')
                    : t('nv_err_generic');
            if (window.__handleError) window.__handleError(e, 'voice-gender:nv', { say: say });
            ae('nv_error', { code: code || null });
        });
    });
    $('vgNvCancel').addEventListener('click', function () { if (ctrl) ctrl.abort(); });

    // ── delivery: the format at the download, billed when the file reached the person ──
    $('vgNvDownload').addEventListener('click', function () {
        if (!result) return;
        var capRun = window.__toolLimit ? window.__toolLimit.begin('voice-gender') : null;
        if (window.__toolLimit && !capRun) return;      // the wall said its own sentence
        var fmt = $('vgNvFormat').value || 'mp3', btn = this, old = btn.innerHTML;
        btn.disabled = true; btn.textContent = t('preparing');
        Promise.resolve(api.encode(result.buffer, fmt)).then(function (enc) {
            var name = 'voice-' + result.voice.id + '-' + Date.now() + '.' + enc.ext;
            var mark = window.__aiMark ? (enc.ext === 'wav' ? window.__aiMark.wav : window.__aiMark.mp3) : null;
            return (mark ? mark(enc.blob, 'voice-gender').catch(function () { return enc.blob; }) : Promise.resolve(enc.blob)).then(function (blob) {
                return Promise.resolve(window.__downloadFile ? window.__downloadFile(blob, name) : false).then(function (ok) {
                    if (ok !== false && capRun) capRun.commit();
                    else if (capRun && capRun.abort) capRun.abort();
                    ae('nv_download', { fmt: enc.ext, v: result.voice.id, ok: ok === false ? 0 : 1 });
                    try { window.__aeFlush && window.__aeFlush(); } catch (e) {}
                });
            });
        }).catch(function (e) {
            if (capRun && capRun.abort) capRun.abort();
            if (window.__handleError) window.__handleError(e, 'voice-gender:nv_download', { say: t('err_browser') });
        }).then(function () { btn.disabled = false; btn.innerHTML = old; });
    });

    function reset() { if (ctrl && busy) ctrl.abort(); result = null; $('vgNvResult').hidden = true; setStatus(''); sync(); }

    return { sync: sync, open: open, reset: reset };
}

window.VGBrowserVoices = { init: init };
})();
